module.exports = __webpack_public_path__ + "img/1586875997.7ca706a8.jpg";